










import Vue from "vue";
import Component from "vue-class-component";
import { LeadService } from "@/services/lead.service";
import { Prop, Watch } from "vue-property-decorator";

interface ComboItem {
  text: string;
  value: string | null;
}

@Component
export default class ComboTipoLead extends Vue {
  @Prop() readonly value!: string | null;
  loading = false;
  tipoLead: ComboItem | null = null;
  itemsTipoLead: ComboItem[] = [];

  @Prop({ required: true }) readonly label!: string; 
  @Prop({ default: () => [] }) readonly rules!: Array<(v: any) => string | undefined>;

  @Watch("value", { immediate: true })
  onValueChange(val: string | null) {
    val = '' + val;
    this.tipoLead = this.itemsTipoLead.find((x) => x.value == val) ?? null;
  }

  @Watch("tipoLead")
  onChangeTipo(val: ComboItem) {
    this.$emit("input", val?.value);
  }

  async fetchTipoLead() {
    this.loading = true;
    const res = await LeadService.obterTipoLead();
    this.itemsTipoLead = res.map((x) => ({
      text: x.nome,
      value: "" + x.idTipoLead,
    }));

    this.itemsTipoLead.unshift({ text: "", value: null });

    if (this.value) {
      this.tipoLead = this.itemsTipoLead.find((x) => x.value == this.value) || null;
    }

    this.loading = false;
  }

  mounted() {
    this.fetchTipoLead();
  }
}
